import icon from "~/assets/reports_logo.svg";
import { ChamferBox, Text } from "snap-design-system";
import { Logo, ReportsIcon, ThemeSwitch } from "snap-design-system";
import UserNavbar from "~/components/UserNavbar";
import { useFolderNavigation } from "~/hooks/useFolderNavigation";
import { Link } from "react-router";
import { useNavigationGuard } from "~/hooks/useNavigationGuard";
import { useUnsavedChangesWarning } from "~/hooks/useUnsavedChangesWarning";
import { useTheme } from '~/hooks/useTheme';

const Header = () => {
  const { isDark, setIsDark } = useTheme();
  const { navigateToRoot } = useFolderNavigation();
  const { shouldBlockNavigation, clearPendingChanges } = useNavigationGuard();
  const { showUnsavedChangesDialog } = useUnsavedChangesWarning({
    hasUnsavedChanges: shouldBlockNavigation,
    onConfirmNavigation: clearPendingChanges,
  });

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (shouldBlockNavigation) {
      showUnsavedChangesDialog(() => {
        navigateToRoot({ shouldInvalidateFilters: true });
      });
      return;
    }

    navigateToRoot({ shouldInvalidateFilters: true });
  };



  return (
    <header className="flex p-8 sticky gap-4 md:gap-8 z-50">
      <div className=" w-full flex items-center gap-4 md:gap-8">
        <div
          className="w-full"
        >
          <Link to={"/"} className="flex w-fit" onClick={handleLogoClick}>
            <Logo variant={"accent"} icon={<ReportsIcon className="text-secondary-500" />} title="Reports" size={"md"} />
          </Link>
        </div>
        <div>
          <UserNavbar />
        </div>
      </div>
      <ThemeSwitch size={"sm"} checked={isDark} onCheckedChange={setIsDark} />
    </header>
  );
};

export default Header;
